import { put, select } from 'redux-saga/effects';
import { signalingLockedContentZoomUpdated } from 'features/content-zoom/actions';
import { remoteZoomSynced } from 'features/content-zoom/contentZoomSlice';
import { buildZoomId, fromServerScale } from 'features/content-zoom/utils/formatUtils';
import { selectLockedContent } from 'features/layout/features/content/contentSlice';
import { ContentData } from 'features/layout/features/content/types';
import { LOCKED_ZOOM_CONTENT_TYPES } from 'features/content-zoom/constants';

export function* onLockedContentZoomUpdatedSaga(
  action: ReturnType<typeof signalingLockedContentZoomUpdated>
) {
  const { scale, offsetX, offsetY } = action.payload;

  const lockedContent: ContentData | null = yield select(selectLockedContent);

  if (!lockedContent || !LOCKED_ZOOM_CONTENT_TYPES.includes(lockedContent.type)) {
    return;
  }

  const zoomId = buildZoomId(lockedContent.id, lockedContent.page);

  yield put(
    remoteZoomSynced({
      zoomId,
      scale: fromServerScale(scale),
      offsetX: offsetX ?? 0,
      offsetY: offsetY ?? 0,
    })
  );
}
